export { LazyLoader } from './LazyLoader';
export type { LazyLoaderProps } from './LazyLoader';
